module.exports = __webpack_public_path__ + "assets/9b01adc896e8099fdf1c5fb38a5c065a.png";